<template>
    <div class="pay-page">
        <div class="service-box" v-if="this.service_info != '' && this.service_info != null && this.service_info != undefined">
            <div class="service-info">
                {{ this.service_info }}
            </div>
            <a-divider></a-divider>
            <div class="service-pic">
                <img :src="this.service_pic" alt="" />
            </div>
        </div>
        <div class="base-box">
            <div class="show-loading-box">
                <a-spin v-if="show_loading" class="show-loading" tip="正在加载分区......" />
            </div>

            <div class="pay-page-header" v-if="page_loaded">
                <a-alert :message="this.group_description" type="info" show-icon />
            </div>

            <div class="pay-notice" v-if="isie">
                <template>
                    <a-alert message="系统检测到您使用的是【微软IE浏览器】，很可能会出现没有任何分区列表的情况，请多次刷新。如果刷新后还是无法显示，建议您更换速度更快性能更好的【360安全浏览器】并启用【极速内核】即可解决。" type="warning" show-icon />
                </template>
            </div>

            <!-- 0 -->
            <div class="choose-zone" v-if="show_choose">
                <a-divider>{{ setp }}</a-divider>
                <!-- 1 -->
                <div class="zone-list-box">
                    <a-row wrap="true" :gutter="[16, 16]">
                        <template v-for="zone in data">
                            <a-col v-if="zone.zonename == '---'" :key="zone.id" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <a-divider>{{ zone.description }}</a-divider>
                            </a-col>
                            <a-col v-else-if="zone.status != 'incoming'" :key="zone.id" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="zone-card" :class="zone.status" @click="choosed(zone)">
                                    <div class="name-box">
                                        <span class="name">{{ zone.zonename }}</span>
                                    </div>
                                    <!-- <div class="remark"><a-icon type="notification" /> {{ zone.description }}</div>
                                    <div class="time-box">
                                        <span class="time"><a-icon type="schedule" /> 正式开区时间：{{ timeformater(zone.opentime) }}</span>
                                    </div> -->
                                    <div class="tag-box">
                                        <span class="tag">{{ zone.tag }}</span>
                                    </div>
                                </div>
                            </a-col>
                        </template>
                    </a-row>
                </div>
            </div>

            <!-- 2 -->
            <div class="form-box" v-if="show_form">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <a-divider>{{ setp }}</a-divider>
                        <template>
                            <a-alert :message="'每充值 1元 可兑换 ' + choosezone.money1scale + ' ' + choosezone.money1name" type="success" show-icon class="mb-4" v-if="choosezone.money1name != '' && choosezone.money1name != undefined && choosezone.money1name != null" />

                            <a-alert :message="'每充值 1元 可兑换 ' + choosezone.money2scale + ' ' + choosezone.money2name" type="success" show-icon class="mb-4" v-if="choosezone.money2name != '' && choosezone.money2name != undefined && choosezone.money2name != null" />

                            <a-alert :message="'每充值 1元 可兑换 ' + choosezone.money3scale + ' ' + choosezone.money3name" type="success" show-icon class="mb-4" v-if="choosezone.money3name != '' && choosezone.money3name != undefined && choosezone.money3name != null" />

                            <a-alert :message="'每充值 1元 可兑换 ' + choosezone.money4scale + ' ' + choosezone.money4name" type="success" show-icon class="mb-4" v-if="choosezone.money4name != '' && choosezone.money4name != undefined && choosezone.money4name != null" />

                            <a-alert :message="'每充值 1元 可兑换 ' + choosezone.money5scale + ' ' + choosezone.money5name" type="success" show-icon class="mb-4" v-if="choosezone.money5name != '' && choosezone.money5name != undefined && choosezone.money5name != null" />

                            <a-alert :message="'每充值 1元 可兑换 ' + choosezone.money6scale + ' ' + choosezone.money6name" type="success" show-icon class="mb-4" v-if="choosezone.money6name != '' && choosezone.money6name != undefined && choosezone.money6name != null" />
                            <a-alert v-if="choosezone.description != '' && choosezone.description != null && choosezone.description != undefined" :message="choosezone.description" type="warning" show-icon class="mb-4" />
                        </template>
                        <a-form :form="form">
                            <a-form-item>
                                <a-input name="zonename" size="large" type="text" addon-before="已选择的分区" v-model="choosezone.zonename" disabled />
                            </a-form-item>
                            <a-form-item>
                                <a-input name="account" size="large" type="text" addon-before="输入充值账号" v-model="account" />
                            </a-form-item>
                            <a-form-item>
                                <a-input name="fee" size="large" type="number" addon-before="输入充值金额" v-model="fee" />
                            </a-form-item>
                            <a-form-item>
                                <a-divider>推荐使用</a-divider>
                                <a-row :gutter="16">
                                    <a-col :span="12">
                                        <a-button type="primary" @click="PostPayRequest(1)" :loading="this.onrequest" size="large" class="btn-alipay" icon="alipay-circle">支付宝 </a-button>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-button type="primary" @click="PostPayRequest(4)" :loading="this.onrequest" size="large" class="btn-wechat" icon="wechat"> 微信支付① </a-button>
                                    </a-col>
                                </a-row>

                                <a-divider>微信备用（仅供上方微信无法使用时备用）</a-divider>
                                <a-row :gutter="16">
                                    <a-col :span="12">
                                        <a-tooltip title="微信风控较为严格，如果微信扫码提示风险，可尝试更换微信账号支付，如无法更换微信账号可联系管理人员处理。">
                                            <a-button type="primary" @click="PostPayRequest(2)" :loading="this.onrequest" class="btn-wechat" icon="wechat"> 微信支付② </a-button>
                                        </a-tooltip>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-tooltip title="微信风控较为严格，如果微信扫码提示风险，可尝试更换微信账号支付，如无法更换微信账号可联系管理人员处理。">
                                            <a-button type="primary" @click="PostPayRequest(3)" :loading="this.onrequest" class="btn-wechat" icon="wechat"> 微信支付③ </a-button>
                                        </a-tooltip>
                                    </a-col>
                                </a-row>
                            </a-form-item>
                            <a-button size="large" class="btn-reset" @click="Return()">
                                返回
                            </a-button>
                        </a-form>
                    </a-col>
                </a-row>
            </div>

            <!-- 3 -->
            <div class="qcode-box" v-if="show_qrcode">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <img :src="qrcode" alt="" class="qrcode" v-if="this.channel == 1 || this.channel == 2" />
                        <vue-qr :text="this.qrcode" colorDark="#f67b29" colorLight="#fff" :size="400" class="qrcode" v-if="this.channel == 3"></vue-qr>
                        <div class="info-box">
                            <div class="info">充值分区：{{ choosezone.zonename }}</div>
                            <div class="info">充值账号：{{ account }}</div>
                            <div class="info">支付金额：{{ total_fee }} 元</div>
                            <div class="info">订单号码：{{ orderid }}</div>
                        </div>

                        <a-button size="large" class="btn-reset" @click="Return()">
                            返回
                        </a-button>
                    </a-col>
                </a-row>
            </div>
            <!-- 4 -->
            <div class="pay-status" v-if="show_result">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <a-result :status="result_status" :title="result_title" :sub-title="reuslt_subtitle"></a-result>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import { GetPayPageZoneList, RequestPayQRcode, GetOrderState } from '@/api/api';
import vueQr from 'vue-qr';
import moment from 'moment';

const columns = [
    {
        dataIndex: 'zonename',
        key: 'name',
        align: 'center',
        title: '游戏分区名称',
        scopedSlots: { customRender: 'name' },
    },
    {
        title: '操作',
        key: 'action',
        align: 'center',
        scopedSlots: { customRender: 'action' },
    },
];

export default {
    components: { vueQr },
    name: 'PayPage',
    data() {
        return {
            isie: false,
            domain: window.location.hostname,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            data: [],
            group_description: '',
            service_info: '',
            service_pic: '',
            page_loaded: false,
            columns,
            setp: '分区列表',
            show_loading: true,
            show_choose: false,
            show_form: false,
            show_qrcode: false,
            show_result: false,
            result_status: 'error',
            result_title: '',
            reuslt_subtitle: '',
            choosezone: {},
            account: '',
            channel: 1,
            fee: 0,
            total_fee: '',
            orderid: '',
            timer: null,
            checktimes: 0,
            qrcode: '',
            onrequest: false,
            qrcodeFromCreate: null,

            pagination: {
                current: 1,
                pageSize: 50,
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => `每页显示${range[1]}条，共有 ${total}条`,
            },
        };
    },
    mounted() {
        document.title = '人物属性修改器';
        this.checkbrower();
        this.fetch();
    },
    methods: {
        checkbrower() {
            var inBrowser = typeof window !== 'undefined';
            var UA = inBrowser && window.navigator.userAgent.toLowerCase();
            var isIE = UA && /msie|trident/.test(UA);
            this.isie = isIE;
        },
        fetch() {
            let params = {
                domain: this.domain,
                path: window.location.search.substr(1),
                pathId: window.location.search.substr(1),
            };
            GetPayPageZoneList(params)
                .then((res) => {
                    // console.log(res);
                    if (res.code == 200) {
                        this.pagination.total = res.total;
                        this.data = res.rows;
                        this.group_description = res.group_description;
                        this.service_info = res.service_info;
                        this.service_pic = res.service_pic;

                        this.data.forEach((zone) => {
                            zone.status = this.check_zone_status(zone.betatime, zone.opentime);
                            if (zone.status == 'opening') {
                                zone.tag = '正式开区';
                                return;
                            }
                            if (zone.status == 'testing') {
                                zone.tag = '正在测试';
                                return;
                            }
                            zone.tag = '即将开放';
                        });
                        this.show_choose = true;
                        this.page_loaded = true;
                        this.show_loading = false;
                    } else {
                        console.log('获取分区列表异常:' + res.msg);
                        this.$warning({ title: '错误', content: res.msg });
                    }
                })
                .catch((error) => {
                    console.log('获取分区列表异常:' + error.message);
                    this.$error({ title: '错误', content: '后台服务器繁忙，请刷新一下！' });
                });
        },
        timeformater(val) {
            if (val != undefined) {
                return moment(val).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        PostPayRequest(channel) {
            this.channel = channel;
            this.requestpay();
        },
        requestpay() {
            this.onrequest = true;
            const data = {
                domain: this.domain,
                zoneid: this.choosezone.id,
                zonename: this.choosezone.zonename,
                account: this.account,
                fee: this.fee,
                channel: this.channel,
            };
            RequestPayQRcode(data)
                .then((res) => {
                    // console.log(res);
                    if (res.code == 200) {
                        switch (this.channel) {
                            case 4:
                                window.location.href = res.qrcode;
                                break;
                            default:
                                this.show_choose = false;
                                this.show_form = false;
                                this.show_qrcode = true;
                                this.total_fee = res.fee;
                                this.orderid = res.orderid;
                                this.qrcode = res.qrcode;
                                break;
                        }
                        this.checktimes = 0;
                        this.timer = setInterval(this.checkorder, 3000, this.orderid);
                    } else {
                        this.$warning({ title: '注意', content: res.msg });
                    }
                    this.onrequest = false;
                })
                .catch((error) => {
                    console.log('获取支付二维码异常:' + error.message);
                    if (error.response.status == 400) {
                        this.$warning({ title: '注意', content: '请完整正确填写表格。' });
                    } else {
                        this.$error({ title: '错误', content: '后台服务器繁忙，请刷新一下！' });
                    }
                    this.onrequest = false;
                });
        },
        choosed(record) {
            this.setp = '填写充值账号金额信息';
            this.show_choose = false;
            this.show_form = true;
            this.choosezone = record;
        },
        Return() {
            this.setp = '分区列表';
            this.show_choose = true;
            this.show_form = false;
            this.show_qrcode = false;
            this.show_result = false;
            this.stop_checktimer();
        },
        checkorder(orderid) {
            this.checktimes++;
            if (this.checktimes >= 60) {
                this.checkorder_stop(0);
            }
            GetOrderState({ orderid: orderid }).then((res) => {
                // console.log(res);
                if (res.code == 200) {
                    this.checkorder_stop(1);
                }
            });
        },
        checkorder_stop(code) {
            if (code == 0) {
                this.result_status = 'error';
                this.result_title = '支付失败';
                this.reuslt_subtitle = '订单号：' + this.orderid + ' 订单已超时，请刷新本页面重新支付。';
            } else {
                this.result_status = 'success';
                this.result_title = '支付成功';
                this.reuslt_subtitle = '订单号：' + this.orderid + ' 已完成，请在游戏内的NPC处领取充值，祝您游戏愉快！';
            }
            this.show_form = false;
            this.show_qrcode = false;
            this.show_result = true;
            this.stop_checktimer();
        },
        stop_checktimer() {
            this.checktimes = 0;
            clearInterval(this.timer);
        },
        isDuringDate(beginDateStr, endDateStr) {
            var curDate = new Date(),
                beginDate = new Date(beginDateStr),
                endDate = new Date(endDateStr);
            if (curDate >= beginDate && curDate <= endDate) {
                return true;
            }
            return false;
        },
        check_zone_status(time1, time2) {
            const now = new Date();
            if (now < new Date(time1)) {
                return 'incoming';
            }
            if (now >= new Date(time2)) {
                return 'opening';
            }
            return 'testing';
        },
    },
};
</script>

<style scoped>
.mb-4 {
    margin-bottom: 16px;
}
.pay-page {
    /* color: #000; */
    height: 100vh;
    overflow: auto;
    background-color: #f5f8fa;
}

.service-box {
    position: fixed;
    background-color: #fff;
    box-shadow: 0 3px 10px -2px rgb(85 85 85 / 8%), 0 2px 20px 0 rgb(85 85 85 / 6%), 0 1px 30px 0 rgb(85 85 85 / 3%);
    border-radius: 4px;
    padding: 20px;
    top: 40px;
    right: 50px;
    width: 180px;
    text-align: center;
}

.service-box .service-info {
    font-size: 12px;
    margin-bottom: 8px;
}

.service-box .service-pic img {
    width: 100%;
}

.pay-page-header {
}

.show-loading-box {
    width: 100%;
    text-align: center;
}
.show-loading {
    /* margin-top: 100px; */
}
.pay-notice {
    margin-bottom: 20px;
}
.pay-notice h1 {
    color: #222;
    font-size: 17px;
    font-weight: 600;
}
.title {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 20px;
}
.zonename {
    color: #333;
    font-size: 21px;
}
.btn-new {
    margin-right: 10px;
}
.qrcode {
    width: 100%;
    margin-bottom: 20px;
}
.info-box {
    border-radius: 4px;
    background-color: #cce5ff;
    border: 1px solid #b8daff;
    padding: 20px;
    margin-bottom: 20px;
}
.info {
    color: #004085;
    font-size: 17px;
    margin-bottom: 5px;
    font-weight: 400;
}
.btn-alipay {
    width: 100%;
}
.btn-wechat {
    background-color: #04be02;
    border: #04be02;
    width: 100%;
}
.btn-reset {
    width: 100%;
    margin-bottom: 20px;
}
/* ============================================================================= */
.base-box {
    padding: 30px;
    width: 680px;
    margin: 40px auto;
    color: #212529;
    box-shadow: 0 3px 10px -2px rgb(85 85 85 / 8%), 0 2px 20px 0 rgb(85 85 85 / 6%), 0 1px 30px 0 rgb(85 85 85 / 3%);

    background-color: #fff !important;
    border-radius: 0.25rem !important;
    /* border: thin solid rgba(0, 0, 0, 0.12); */
}

.pay-box {
}

.form-box {
}
/* 二维码 */
.qcode-box {
}
/* 支付结果 */
.pay-status {
}
/* ============================================================================= */
.zone-list-box {
    /* text-align: center; */
}
.zone-card {
    position: relative;
    /* border: 1px solid rgba(0, 0, 0, 0.06); */
    cursor: pointer;
    padding: 15px 30px;
    border-radius: 4px;
    /* box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%); */
    background: #f5f5f5;
    transition: all 0.3s ease-out;
    z-index: 10;
    color: rgba(0, 0, 0, 0.87);
}
.zone-card:hover {
    /* box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%); */
}

.zone-card .name-box {
    /* padding: 10px 20px; */
    /* align-items: center; */
    /* border-bottom: 1px solid rgba(0, 0, 0, 0.12); */
    /* margin-bottom: 8px; */
    display: flex;
    align-items: center;
}

.zone-card .name {
    color: rgba(0, 0, 0, 0.87);
    font-size: 17px;
    font-weight: 700;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.zone-card .remark {
    /* margin-bottom: 4px; */
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.zone-card .tag-box {
}
.zone-card .tag {
    position: absolute;
    right: 16px;
    top: 16px;
    border-radius: 4px;
    /* font-weight: 300; */
    font-size: 12px;
    padding: 2px 8px 4px;
    display: inline-block;
}

.zone-card .time-box {
    /* border-top: 1px solid rgba(0, 0, 0, 0.12); */
    /* padding: 10px 20px; */
}
.zone-card .time {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    /* margin-top: 10px; */
    font-size: 13px;
    font-weight: 400;
}

/* ============================================================================= */
.zone-card.incoming {
    display: none;
    border: 1px solid #e0e0e0;
    color: #e0e0e0;
}

.zone-card.incoming .name {
    color: #e0e0e0;
}

.zone-card.incoming .time {
    font-family: Tahoma;
    font-size: 10px;
    color: #e0e0e0;
}

.zone-card.incoming .tag {
    border: 1px solid #e0e0e0;
    background-color: #e0e0e0;
    color: #fff;
}

.zone-card.incoming .remark {
    color: #e0e0e0;
}

/* ============================================================================= */
.zone-card.testing {
    /* border: 1px solid #4a148c; */
    /* color: #4a148c; */
}
.zone-card.testing .name {
}

.zone-card.testing .time {
    color: rgba(0, 0, 0, 0.6);
}

.zone-card.testing .tag {
    background: #f50057;
    color: #fff;
}

.zone-card.testing .remark {
    color: rgba(0, 0, 0, 0.6);
}

.zone-card.testing:hover {
    background: #4a148c;
    color: #fff;
}

.zone-card.testing:hover .name {
    color: #fff;
}
.zone-card.testing:hover .remark {
    color: hsla(0, 0%, 100%, 0.7);
}
.zone-card.testing:hover .time {
    color: hsla(0, 0%, 100%, 0.7);
}
/* ============================================================================= */
.zone-card.opening {
    /* border: 1px solid #006064; */
    /* color: #006064; */
}
.zone-card.opening .name {
}

.zone-card.opening .time {
    color: rgba(0, 0, 0, 0.6);
}

.zone-card.opening .tag {
    background: #52c41a;
    color: #fff;
}
.zone-card.opening .remark {
    color: rgba(0, 0, 0, 0.6);
}

.zone-card.opening:hover {
    background: #1890ff;
    color: #fff;
}

.zone-card.opening:hover .name {
    color: #fff;
}
.zone-card.opening:hover .remark {
    color: hsla(0, 0%, 100%, 0.7);
}
.zone-card.opening:hover .time {
    color: hsla(0, 0%, 100%, 0.7);
}
</style>
